// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3thNw","col":"styles_col__2TVGH"};